import type {
  NavigationGuardNext,
  RouteLocationNormalized,
  Router,
} from "vue-router";
import { useUserStore } from "@/stores";
import { loginPaths, noCertPaths } from "@/resources/constants";

const userGuard = async (
  to: RouteLocationNormalized,
  _: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const userStore = useUserStore();

  const isLoginPath = loginPaths.includes(to.name?.toString() ?? "");
  if (!userStore.isLoggedIn && !isLoginPath) {
    return next({
      name: "Login",
      query: { redirect: to.fullPath },
      force: true,
    });
  }
  const redirectPath = to.query.redirect?.toString();
  if (isLoginPath && userStore.isLoggedIn && redirectPath) {
    return next({ path: redirectPath, force: true });
  }
  await userStore.getUser();
  next();
};

export default (router: Router) => {
  router.beforeEach(userGuard);
};
